/** 是否在浏览器环境，SSR 场景下为 false */
export const isBrowser = typeof window !== 'undefined';

/** 类型守卫：判断值是否为 string */
export const isString = (value: unknown): value is string =>
  typeof value === 'string';

/** 类型守卫：判断值是否为 number */
export const isNumber = (value: unknown): value is number =>
  typeof value === 'number';

/** 类型守卫：判断值是否严格等于 true（排除 truthy 值） */
export const isTrue = (value: unknown): value is true => value === true;

/** 类型守卫：判断值是否为数组（Array.isArray 的别名） */
export const isArray = Array.isArray;

/** 类型守卫：判断值是否为函数 */
export const isFunction = (value: unknown): value is (...args: any[]) => any =>
  typeof value === 'function';

/** Object.prototype.toString 的引用，用于精确类型判断 */
export const objectToString = Object.prototype.toString;

/** 返回值的 [object Xxx] 类型字符串，比 typeof 更精确 */
export const toTypeString = (value: unknown): string =>
  objectToString.call(value);

/** 类型守卫：判断值是否为纯对象（排除 Array、Date、Map 等内置类型） */
export const isPlainObject = (value: unknown): value is Record<any, any> =>
  toTypeString(value) === '[object Object]';
